import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";


function* getPanelAccessResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/Generic/FetchPanelAccess", data);
        if (response?.statusCode === 1200) {
            yield put(actions.getPanelAccessSuccess(response?.data));
        } else {
            yield put(actions.getPanelAccessError(response?.message || "Failed to get panel access list"));
        }
    } catch (error) {
        yield put(actions.getPanelAccessError(error?.message || error)
        );
    }
}


function* updatePanelAccessResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/Generic/UpdatePanelAccess", data);
        if (response?.statusCode === 1200) {
            yield put(actions.updatePanelAccessSuccess(response?.message));
        } else {
            yield put(actions.updatePanelAccessError(response?.message || "Failed to update panel access"));
        }
    } catch (error) {
        yield put(actions.updatePanelAccessError(error?.message || error)
        );
    }
}

// ROOT SAGA
export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_PANEL_ACCESS, getPanelAccessResponse),
        takeEvery(actions.UPDATE_PANEL_ACCESS, updatePanelAccessResponse),
    ]);
}